/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import getSoporteDebidaDiligencia from './_soporteDebidaDiligencia.css';
import getGridTypes from './_gridTypes.css';
import getPersonalNonCCD from './_personalNonCCD.css';
import getPersonalComplianceUploads from './_personalComplianceUploads.css';
import getUtilityclasses from './_utilityclasses.css';
import getFlex from './_flex.css';

const styles = [getSoporteDebidaDiligencia, getGridTypes, getPersonalNonCCD, getPersonalComplianceUploads, getUtilityclasses, getFlex];

export default $ => css(styles.map(style => style($)));
